import React from 'react';
import { Breadcrumb } from 'antd';
import { breadcrumbsSelector } from 'state/slices/breadcrumb';
import { useSelector } from 'hooks/store';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';

import {
  ClickableCrumb,
} from './style';

const SectionBreadcrumb = (): JSX.Element | null => {
  const breadcrumbs = useSelector(breadcrumbsSelector);
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const onCrumbClick = (index: number) => {
    breadcrumbNavigator.toCrumb(index);
  };

  return breadcrumbs.length > 1 ? (
    <Breadcrumb>
      {breadcrumbs.map((crumb, index) => (
        <Breadcrumb.Item key={crumb.url}>
          {
            index !== breadcrumbs.length - 1 ? (
              <ClickableCrumb onClick={() => onCrumbClick(index)}>
                {crumb.label}
              </ClickableCrumb>
            ) : (
              crumb.label
            )
          }
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  ) : null;
};

export default SectionBreadcrumb;
